<svelte:options accessors={true} />

<script>
  import { createEventDispatcher, onDestroy } from 'svelte';

  import Button from '../button.svelte';
  import RingLoadingSpinner from '../ringLoadingSpinner.svelte';

  export let peerName;
  export let videoConsumer;
  export let audioConsumer;
  export let volume;
  export let muteButtonLoading = false;
  export let isMuted = false;
  export const playVideo = async () => {
    console.log('playVideo' + video + ' ' + videoConsumer + ' ' + videoLoading);
    if (video && videoConsumer && !videoLoading) {
      console.log('can play video');
      videoLoading = true;
      try {
        video.srcObject = new MediaStream([videoConsumer.track.clone()]);
        await video.play();
      } catch (error) {
        console.error(error);
      }
      videoLoading = false;
    }
    console.log('playVideo end');
  };
  export const playAudio = async () => {
    console.log('playAudio' + audio + ' ' + audioConsumer + ' ' + audioLoading);
    if (audio && audioConsumer && !audioLoading) {
      console.log('can play audio');
      audioLoading = true;
      try {
        audio.srcObject = new MediaStream([audioConsumer.track.clone()]);
        await audio.play();
      } catch (error) {
        console.error(error);
      }

      audioLoading = false;
    }
    console.log('playAudio end');
  };

  onDestroy(() => {
    console.log('the component is being destroyed');
  });

  let dispatch = createEventDispatcher();

  function onMuteButtonClick() {
    isMuted = !isMuted;
    dispatch('muteButtonClick', { isMuted });
  }

  let video;
  let audio;

  let videoLoading = false;
  let audioLoading = false;
</script>

<div class="container">
  <div class="peerInfoContainer">
    <p class="peerName" class:speaking={volume >= -60}>{peerName}</p>
  </div>
  <div class="mute-container">
    <Button label="Mute" type="minimalist" size="small" isLoading={muteButtonLoading} on:click={onMuteButtonClick} />
  </div>
  {#if !videoConsumer || !audioConsumer}
    <div class="loading">
      <RingLoadingSpinner size="1.5em" color="#ffffff" />
    </div>
  {/if}
  <!-- svelte-ignore a11y-media-has-caption -->
  <video bind:this={video} />
  <audio bind:this={audio} />
</div>

<style>
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -0.75em;
    margin-top: -0.75em;
  }
  .mute-container {
    position: absolute;
    top: 25px;
    right: 25px;
    width: 100px;
    z-index: 50;
  }
  .peerName {
    color: white;
  }
  .peerInfoContainer {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 25px;
    margin-bottom: 25px;
    padding-left: 15px;
    padding-right: 15px;
    background: rgba(22, 30, 47, 0.5);
    backdrop-filter: blur(50px);
    height: 50px;
    border-radius: 10px;
    z-index: 50;
  }
  .container {
    width: 100%;
    padding-top: 56.25%;
    height: 0px;
    position: relative;
    background: #253045;
    border-radius: 10px;
  }
  .speaking {
    box-shadow: 0 0 0 5px green;
  }

  video {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
  }
</style>
